import jwt from "jsonwebtoken";

import {
  LOGIN_EMPLOYEE,
  LOGIN_EMPLOYEE_SUCCESS,
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_ERROR,
  LOGIN_USER_UPDATE_JWT,
  REGISTER_USER,
  REGISTER_USER_SUCCESS,
  REGISTER_USER_ERROR,
  LOGOUT_USER,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_ERROR,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_ERROR,
  UPDATE_PROFILE,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_ERROR,
  REFRESH_JWT_SUCCESS,
  REFRESH_JWT_FAILURE,
  REFRESH_JWT,
  PASSWORD_EXPIRED,
  PASSWORD_EXPIRED_DISMISS,
  PASSWORD_EXPIRY_WARNING,
} from "../actions";

const INIT_STATE = {
  employee:
    localStorage.getItem("jwt") &&
    jwt.decode(localStorage.getItem("jwt"))["employee"]
      ? jwt.decode(localStorage.getItem("jwt"))["employee"]
      : null,
  user: localStorage.getItem("jwt")
    ? jwt.decode(localStorage.getItem("jwt"))["username"]
    : null,
  jwt: localStorage.getItem("jwt"),
  jwtRefresh: localStorage.getItem("jwtRefresh"),
  roles: localStorage.getItem("jwt")
    ? jwt.decode(localStorage.getItem("jwt"))["groups"]
    : null,
  facility: localStorage.getItem("jwt")
    ? jwt.decode(localStorage.getItem("jwt"))["facility"]
    : null,
  user_id: localStorage.getItem("jwt")
    ? jwt.decode(localStorage.getItem("jwt"))["user_id"]
    : null,
  forgotUserMail: "",
  newPassword: "",
  resetPasswordCode: "",
  loading: false,
  error: "",
  passwordExpired: false,
  passwordExpiredReason: null, // 'admin' or 'natural'
  daysRemaining: null,
  showPasswordExpiredModal: false,
  dark_mode: localStorage.getItem("dark_mode"),
  first_name:
    localStorage.getItem("jwt") &&
    jwt.decode(localStorage.getItem("jwt"))["profile"]
      ? jwt.decode(localStorage.getItem("jwt"))["profile"]["first_name"]
      : null,
  last_name:
    localStorage.getItem("jwt") &&
    jwt.decode(localStorage.getItem("jwt"))["profile"]
      ? jwt.decode(localStorage.getItem("jwt"))["profile"]["last_name"]
      : null,
  client_name:
    localStorage.getItem("jwt") &&
    jwt.decode(localStorage.getItem("jwt"))["client_name"]
      ? jwt.decode(localStorage.getItem("jwt"))["client_name"]
      : null,
  mobile:
    localStorage.getItem("jwt") &&
    jwt.decode(localStorage.getItem("jwt"))["profile"]
      ? jwt.decode(localStorage.getItem("jwt"))["profile"]["mobile"]
      : null,
  timezone:
    localStorage.getItem("jwt") &&
    jwt.decode(localStorage.getItem("jwt"))["profile"]
      ? jwt.decode(localStorage.getItem("jwt"))["profile"]["timezone"]
      : null,
  profile_pic: localStorage.getItem("profile_pic"),
  channel_name:
    localStorage.getItem("jwt") &&
    jwt.decode(localStorage.getItem("jwt"))["profile"]
      ? jwt.decode(localStorage.getItem("jwt"))["channel_name"]
      : null,
  channel_list:
    localStorage.getItem("jwt") &&
    jwt.decode(localStorage.getItem("jwt"))["profile"]
      ? jwt.decode(localStorage.getItem("jwt"))["channel_list"]
      : null,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case LOGIN_EMPLOYEE:
      return { ...state, loading: true, error: "" };
    case LOGIN_EMPLOYEE_SUCCESS:
      // console.log("jwwwwttt", jwt.decode(action.payload.jwt), action.payload);
      // console.log("jwwwwtttRRRRRRRRRR", jwt.decode(action.payload.access_token));
      return {
        ...state,
        loading: false,
        employee: jwt.decode(action.payload.access_token)["employee"],
        user: jwt.decode(action.payload.access_token)["username"],
        user_id: jwt.decode(action.payload.access_token)["user_id"],
        jwt: action.payload.access_token,
        jwtRefresh: action.payload.jwt,
        // roles: action.payload.roles,
        roles: jwt.decode(action.payload.access_token)["groups"],
        facility: jwt.decode(action.payload.access_token)["facility"],
        first_name: jwt.decode(action.payload.access_token)["profile"][
          "first_name"
        ],
        last_name: jwt.decode(action.payload.access_token)["profile"][
          "last_name"
        ],
        client_name: jwt.decode(action.payload.access_token)["client_name"],
        mobile: jwt.decode(action.payload.access_token)["profile"]["mobile"],
        timezone: jwt.decode(action.payload.access_token)["profile"][
          "timezone"
        ],
        profile_pic: jwt.decode(action.payload.access_token)["profile"][
          "profile_pic"
        ],
        channel_name: jwt.decode(action.payload.access_token)["channel_name"],
        channel_list: jwt.decode(action.payload.access_token)["channel_list"],
        error: "",
      };
    case LOGIN_USER:
      return { ...state, loading: true, error: "" };
    case LOGIN_USER_SUCCESS:
      // console.log("jwwwwttt", jwt.decode(action.payload.access));
      return {
        ...state,
        loading: false,
        user: jwt.decode(action.payload.access)["username"],
        user_id: jwt.decode(action.payload.access)["user_id"],
        jwt: action.payload.access,
        jwtRefresh: action.payload.refresh,
        // roles: action.payload.roles,
        roles: jwt.decode(action.payload.access)["groups"],
        facility: jwt.decode(action.payload.access)["facility"],
        first_name: action.payload.profile.first_name,
        last_name: action.payload.profile.last_name,
        client_name: action.payload.client_name,
        mobile: action.payload.profile.mobile,
        timezone: action.payload.profile.timezone,
        profile_pic: action.payload.profile.profile_pic,
        channel_name: jwt.decode(action.payload.access)["channel_name"],
        channel_list: jwt.decode(action.payload.access)["channel_list"],
        error: "",
      };
    case LOGIN_USER_ERROR:
      return {
        ...state,
        loading: false,
        user: "",
        error: action.payload.message,
      };
    case LOGIN_USER_UPDATE_JWT:
      return {
        ...state,
        jwt: action.payload.access,
      };
    case FORGOT_PASSWORD:
      return { ...state, loading: true, error: "" };
    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        forgotUserMail: action.payload,
        error: "",
      };
    case FORGOT_PASSWORD_ERROR:
      return {
        ...state,
        loading: false,
        forgotUserMail: "",
        error: action.payload.message,
      };
    case RESET_PASSWORD:
      return { ...state, loading: true, error: "" };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        newPassword: action.payload,
        resetPasswordCode: "",
        error: "",
      };
    case RESET_PASSWORD_ERROR:
      return {
        ...state,
        loading: false,
        newPassword: "",
        resetPasswordCode: "",
        error: action.payload.message,
      };
    case REGISTER_USER:
      return { ...state, loading: true, error: "" };
    case REGISTER_USER_SUCCESS:
      return { ...state, loading: false, user: "", error: "" };
    case REGISTER_USER_ERROR:
      return {
        ...state,
        loading: false,
        user: "",
        error: action.payload.message,
      };
    case LOGOUT_USER:
      return {
        ...state,
        user: null,
        user_id: null,
        jwt: null,
        jwtRefresh: null,
        roles: null,
        facility: null,
        error: null,
        first_name: null,
        last_name: null,
        client_name: null,
        mobile: null,
        timezone: null,
        channel_list: null,
        channel_name: null,
      };

    case CHANGE_PASSWORD:
      return { ...state, loading: true, error: "" };
    case CHANGE_PASSWORD_SUCCESS:
      return { ...state, loading: false, error: "" };
    case CHANGE_PASSWORD_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };

    case UPDATE_PROFILE:
      return { ...state, loading: true, error: "" };
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,

        first_name: action.payload.first_name,
        last_name: action.payload.last_name,
        mobile: action.payload.mobile,
        timezone: action.payload.timezone,
        profile_pic: action.payload.profile_pic,

        error: "",
      };
    case UPDATE_PROFILE_ERROR:
      return {
        ...state,
        loading: false,
        user: "",
        error: action.payload.message,
      };

    case REFRESH_JWT:
      return { ...state, loading: true, error: "" };
    case REFRESH_JWT_SUCCESS:
      return {
        ...state,
        loading: false,

        jwt: action.payload,

        error: "",
      };
    case REFRESH_JWT_FAILURE:
      return {
        ...state,
        loading: false,
        user: "",
        error: action.payload.message,
      };

    case PASSWORD_EXPIRED:
      return {
        ...state,
        passwordExpired: true,
        passwordExpiredReason: action.payload.reason,
        daysRemaining: action.payload.daysRemaining,
        showPasswordExpiredModal: true,
      };

    case PASSWORD_EXPIRED_DISMISS:
      return {
        ...state,
        passwordExpired: false,
        passwordExpiredReason: null,
        daysRemaining: null,
        showPasswordExpiredModal: false,
      };

    case PASSWORD_EXPIRY_WARNING:
      return {
        ...state,
        daysRemaining: action.payload.daysRemaining,
      };

    default:
      return { ...state };
  }
};
